import { createContext } from "react";
import { Account, AccountSelectGroup } from "@rentablo/api/apiv1";
import { useAccountIdsByTypes } from "@hooks";

export interface DashboardSelectedGroupsContextProps {
  selectedGroup: AccountSelectGroup | undefined;
  accountIds: number[] | undefined;
  accounts: Account[] | undefined;
  groupedAccountIds: ReturnType<typeof useAccountIdsByTypes>;
  isFetching: boolean;
  isPending: boolean;
  refetch: () => void;
}

export const DashboardSelectedGroupsContext = createContext<
  DashboardSelectedGroupsContextProps | undefined
>(undefined);
